import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { Credentials } from "auth";
import { ClientApp } from "models";
import { State } from "redux/state";

import { getString } from "utils/Utils";

export type FetchApp = "FETCH_APP";
export const FETCH_APP: FetchApp = "FETCH_APP";
export type FetchAppEnd = "FETCH_APP_END";
export const FETCH_APP_END: FetchAppEnd = "FETCH_APP_END";

export interface FetchAppAction extends Action {
    type: FetchApp;
    payload: {
        appId: string;
        credentials: Credentials;
        selectOnSuccess?: boolean;
    };
}

export function fetchApp(
    appId: string | { appId: string },
    selectOnSuccess?: boolean
): ThunkAction<void, State, undefined, FetchAppAction> {
    return (dispatch: Dispatch<FetchAppAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(fetchAppWithCredentials(appId, credentials, selectOnSuccess));
    };
}

function fetchAppWithCredentials(
    appId: string | { appId: string },
    credentials: Credentials,
    selectOnSuccess?: boolean
): FetchAppAction {
    return {
        payload: {
            appId: getString(appId, "appId"),
            credentials,
            selectOnSuccess
        },
        type: FETCH_APP
    };
}

export interface FetchAppEndAction {
    type: FetchAppEnd;
    payload: {
        app?: ClientApp;
        error?: Error;
        selectOnSuccess?: boolean;
    };
}

export function fetchAppEnd(error: Error, app?: ClientApp, selectOnSuccess?: boolean): FetchAppEndAction {
    return {
        payload: {
            app,
            error,
            selectOnSuccess
        },
        type: FETCH_APP_END
    };
}
